import NotificationSettingsRecordUpdate from "@app/types/notifications/NotificationSettingsRecordUpdate";

import getRecordOwnershipLevelSettingsState from "./getRecordOwnershipLevelSettingsState";

const getRecordSettingsState = (enabled: boolean): NotificationSettingsRecordUpdate => ({
  enabled,
  owned: getRecordOwnershipLevelSettingsState(enabled),
  shared: getRecordOwnershipLevelSettingsState(enabled),
});

export default getRecordSettingsState;
